import gql from "graphql-tag"

const SAVE_GALLERY_TEXT_ITEM = gql`
  mutation SaveGalleryTextItem($input: SaveGalleryTextItemInput!) {
    saveGalleryTextItem(input: $input)
  }
`
export default SAVE_GALLERY_TEXT_ITEM
